export interface SupportedLanguage {
    /** Weglot language tag, or null for the untranslated original. */
    tag: string | null;
    /** Written in its own language, so it is readable to the person choosing it. */
    name: string;
}

/**
 * The languages the picker offers.
 *
 * A language listed here must also be enabled in the Weglot project, or selecting it
 * makes `switchTo` a silent no-op and the page simply stays English.
 *
 * Tags are lower-cased because that is what `classifyLangTag` stores: an entry cased any
 * other way would never match the remembered language, and the picker would show no
 * selection after a reload.
 *
 * `null` is the untranslated original, which is the only English that means "do not
 * translate" -- `en-GB` and `en-CA` are ordinary Weglot targets.
 */
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
    { tag: null, name: 'English' },
    { tag: 'en-gb', name: 'English (GB)' },
    { tag: 'en-ca', name: 'English (CA)' },
    { tag: 'de-de', name: 'Deutsch' },
    { tag: 'de-ch', name: 'Deutsch (CH)' },
    { tag: 'es-us', name: 'Español' },
    { tag: 'fr-ca', name: 'Français (CA)' },
    { tag: 'fr-ch', name: 'Français (CH)' },
    { tag: 'fr-fr', name: 'Français (FR)' },
    { tag: 'it-it', name: 'Italiano' },
    { tag: 'nl-nl', name: 'Nederlands' },
];

export default SUPPORTED_LANGUAGES;
